/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TagIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6ElEQVR4nOWVQQrCMBBFew6t3kfazEwWOgMF9SbpgVxKvYqIIugNPECVFrtoizZpU1z4IbvwXjKTIUHwN1EkG0A+AUkOJM9PSyHfY+KFGxw5/QZtSUhuo8HhvbzAFfI+ipZTrZMQUDIngc3JtU7Caj8iz6wFtmXRfQRONUfJCkkJRz50Cvo2FGya7BMOTYFC3vqEA0neEMjZp0CRHOsCkofXG8BqXRMA8c7b6ZHTVoMBZKJIrqPAq8Txcg7IlwECE3RlgMR0wgdIjDW8h8Q4wx0kpjfcQmIGw6sUT7iYk3IYiz+5OUS/zgvjI1L7Lw0UAgAAAABJRU5ErkJggg==)
 */
export const TagIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12.24 2a3 3 0 0 0-2.12.88l-8.25 8.25a3 3 0 0 0 0 4.24l6.76 6.76a3 3 0 0 0 4.24 0l8.25-8.25a3 3 0 0 0 .88-2.12V4a2 2 0 0 0-2-2h-7.76ZM17 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
